import axios from "axios";
import { toast } from "react-toastify";

const postCreateNewGame = async (mapHeight, mapWidth) => {
  try {
    const params = { mapHeight, mapWidth };
    const { data } = await axios.post(`/game`, params);
    return data;
  } catch (error) {
    toast.error(
      `Error creating new game: ${
        error.response?.data?.message || error.message
      }`
    );
  }
};

const postNextStep = async (id, prompt) => {
  try {
    const { data } = await axios.get(`/game/${id}/nextStep`, {
      params: { aiAgentPrompt: prompt },
    });

    return data;
  } catch (error) {
    toast.error(
      `Error creating new step: ${
        error.response?.data?.message || error.message
      }`
    );
  }
};

export default {
  postCreateNewGame,
  postNextStep,
};
